import {FeatureTypeEnum} from "../enums/FeatureTypeEnum";
import {useAuth} from "./useAuth";
import {FeatureStatusEnum} from "../enums/FeatureStatusEnum";
import {IOrganisationFeatures} from "../services/nestjs-base-api/types";

export const useFeatureValue = (featureToCheck: FeatureTypeEnum, defaultValue: any) => {
    const { user } = useAuth();
    
    let isActive = false;
    let value = defaultValue;

    if (user.organisation?.organisationFeaturesDto) {
        try {
            const organisationFeatures: IOrganisationFeatures = JSON.parse(user.organisation.organisationFeaturesDto);
            
            const featureInQuestion = organisationFeatures.features.find(
                (feature) => feature.name === featureToCheck
            );

            if (featureInQuestion && featureInQuestion.specification.status === FeatureStatusEnum.Active) {
                isActive = true;
                value = featureInQuestion.specification.value;
            }
        } catch (error) {
            console.error('Error parsing organisation features:', error);
        }
    }

    return [value, isActive];
};
